import React, { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import SettingsForm from "./SettingsForm";
import MediaAPI from "../../../api/MediaAPI";
import { getTranslatedMetadata } from "../../../utils/data/Content";
import CircularSpinner from "../../utils/loaderEditor/CircularSpinner";

import type { JSX } from "react";

import type { MediaFormat } from "../../../constants/media";
import type { AppState } from "../../../reducers";

export default function Settings(): JSX.Element {
  const getMediasMetadataListQuery = MediaAPI.generateQuery({
    fn: MediaAPI.getMediasMetadataList,
    params: [],
  });

  const { data: metadataData, isLoading: getMediasMetadataListIsLoading } =
    useQuery(getMediasMetadataListQuery);

  const languageId = useSelector(
    (state: AppState) => state.languages.current.uuid,
  );

  const mediaTypeList: {
    label: string;
    key: MediaFormat;
  }[] = useMemo(
    () =>
      metadataData?.formats.map((format) => ({
        label: getTranslatedMetadata(format, "title", languageId),
        key: format.key,
      })) ?? [],
    [languageId, metadataData?.formats],
  );

  return (
    <div className="w-full">
      {getMediasMetadataListIsLoading ? (
        <div className="m-[3.125rem] flex justify-center">
          <CircularSpinner loading />
        </div>
      ) : (
        <SettingsForm mediaTypeList={mediaTypeList} />
      )}
    </div>
  );
}
